/**
 * Process-wide analytics policy for THIS checkout-app mount.
 *
 * The canonical Pages storefront mounts the checkout app for its concierge +
 * commerce (`addToBag`) surface, but owns analytics ITSELF (it re-emits the
 * page-view + commerce events with the canonical `webApp:organic:*` shapes so
 * Mixpanel keeps the same metrics). If the checkout app ALSO fired its own
 * Mixpanel events on a Pages surface, every commerce event would double-count.
 *
 * So the storefront mounts with `suppressAnalytics: true`, which flips this
 * flag and makes the shared `useTracking` `track` wrapper a no-op. It gates
 * ONLY events that flow through `useTracking` (the app's page-view + action
 * events); concierge tracking uses `AnalyticsService.track` directly and is
 * deliberately unaffected (the storefront keeps the concierge integration).
 *
 * A module singleton (not React context) because the mount options are fixed
 * for the lifetime of a mount and `useTracking` is used throughout the tree.
 */
let suppressed = false;

export function setCheckoutAnalyticsSuppressed(value: boolean): void {
  suppressed = !!value;
}

export function isCheckoutAnalyticsSuppressed(): boolean {
  return suppressed;
}
